import { ExtensionInfo } from 'hooks/embedded-status/useEmbeddedStatusSwr';
import { useMemo } from 'react';
import { findThankYouPageExtension } from '../integrationStatusUtils';
import { CustomerAccountPageIntegration } from './customer-account-page-integration/CustomerAccountPageIntegration';
import { ThankYouPageIntegration } from './thank-you-page-integration/ThankYouPageIntegration';

export const SelectedPackagePointIntegrations = ({
    extensions,
    isLoading,
    condensed,
    handleClickAddStoreAppBlock,
}: SelectedPackagePointIntegrationsProps) => {
    const thankYouPageIntegration = useMemo(() => findThankYouPageExtension(extensions), [extensions]);
    return (
        <>
            <ThankYouPageIntegration
                thankYouPageIntegration={thankYouPageIntegration}
                isLoading={isLoading}
                condensed={condensed}
                handleClickAddStoreAppBlock={handleClickAddStoreAppBlock}
            />
            <s-divider />
            <CustomerAccountPageIntegration
                customerAccountPageIntegration={thankYouPageIntegration}
                isLoading={isLoading}
                condensed={condensed}
                handleClickAddStoreAppBlock={handleClickAddStoreAppBlock}
            />
        </>
    );
};

interface SelectedPackagePointIntegrationsProps {
    extensions: ExtensionInfo[];
    isLoading: boolean;
    condensed?: boolean;
    handleClickAddStoreAppBlock?: () => void;
}
